<div class="page-layout simple full-width">
    <!-- HEADER -->
    <div class="header p-24 pb-0" fxLayout="row" fxLayoutAlign="space-between center">

        <div fxLayout="column" fxLayoutAlign="center start" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
            <div class="h2 mt-5"> Centro de Ayuda </div>
        </div>

        <button mat-button [routerLink]="'/' + pathUrlList" class="mt-0 mt-md-0">
            <mat-icon>arrow_back</mat-icon>
            <span>Volver</span>
        </button>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content p-24">

        <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">

            <mat-progress-bar *ngIf="isLoading" mode="buffer"></mat-progress-bar>

            <!-- REACTIVE FORM EXAMPLE -->

            <div *ngIf="!isLoading" class="mat-card mat-elevation-z4 p-24" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto" name="form">

                <ng-container *ngFor="let field of configFields">

                    <mat-form-field *ngIf="field.type == 'string'" appearance="outline" class="pl-4">
                        <mat-label>{{ field.title }}</mat-label>
                        <input matInput [name]="field.key" [(ngModel)]="item[field.key]" />
                    </mat-form-field>

                    <mat-form-field *ngIf="field.type == 'text'" appearance="outline" class="pl-4">
                        <mat-label>{{ field.title }}</mat-label>
                        <textarea matInput [name]="field.key" [(ngModel)]="item[field.key]"></textarea>
                    </mat-form-field>

                    <mat-form-field  *ngIf="field.type == 'select'" appearance="outline" fxFlex="80">
                        <mat-label>{{ field.title }}</mat-label>
                        <mat-select name="parent_id" [(ngModel)]="item[field.key]">
                            <mat-option *ngFor="let opt of field.options" [value]="opt.value">
                                {{ opt.title }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                </ng-container>

                <h3>Preguntas:</h3>

                <mat-card *ngFor="let question of item['questions']; let indexQuestion = index" style="margin-bottom: 10px;" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between">
                    <mat-form-field appearance="outline" class="pl-4" fxFlex="35">
                        <mat-label>Titulo de la pregunta</mat-label>
                        <input matInput [name]="'title_quest_' + indexQuestion" [(ngModel)]="question.title" />
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="pl-4" fxFlex="60">
                        <mat-label>Texto</mat-label>
                        <textarea matInput [name]="'caption_quest_' + indexQuestion" [(ngModel)]="question.caption" style="height: 120px;"></textarea>
                    </mat-form-field>

                    <button (click)="removeQuestion(question)" mat-raised-button color="warn" fxFlex="50px" style="margin-left: 5px; height: 50px;">X</button>
                </mat-card>

                <mat-progress-bar *ngIf="isSending" mode="buffer"></mat-progress-bar>

                <div *ngIf="!isSending" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center">
                    <div>
                        <button (click)="addQuestion()" mat-raised-button color="info" class="mt-24 mt-md-0 mr-4">
                            <span>Agregar pregunta</span>
                        </button>
                    </div>

                    <div>
                        <button [routerLink]="'/' + pathUrlList" mat-raised-button color="warn" class="mt-24 mt-md-0 mr-4">
                            <span>Cancelar</span>
                        </button>
    
                        <button type="button" (click)="onClickSave()" mat-raised-button color="primary" class="mt-24 mt-md-0">
                            <span>Guardar y volver</span>
                        </button>
                    </div>
                </div>

                



            </div>

            <!-- / REACTIVE FORM EXAMPLE -->

        </div>

    </div>
    <!-- / CONTENT -->
</div>